export default "__VITE_ASSET__KFAJlZh9__"